(function () {
  var CLS = "HFB-075-AB--var-1";

  function place() {
    if (!document.documentElement.classList.contains(CLS)) return;
    if (document.querySelector(".hfb-075")) return;
    var anchor = document.querySelector(".bm-strength, .spdp-v2-qty, .product-subscription-wrapper, .buy-button, .product-main-add");
    if (!anchor) return;
    var row = document.createElement("p");
    row.className = "hfb-075";
    row.innerHTML = '<span class="hfb-075__dot" aria-hidden="true"></span><span><strong>1,240 bottles</strong> ordered in the last 24 hours</span>';
    anchor.parentNode.insertBefore(row, anchor);
  }

  function watch() {
    if (document.documentElement.classList.contains(CLS)) place();
    var obs = new MutationObserver(function () {
      if (document.documentElement.classList.contains(CLS)) place();
    });
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch);
  else watch();
})();
